import {useCustomerResponse} from './customer.hooks';

export const useCustomerIsVip = () => {
  return useCustomerResponse().data?.isVIP ?? false;
};

export const useCustomerBiData = () => {
  const data = useCustomerResponse().data;
  if (data?.isVIP) {
    return {
      isVIP: data.isVIP,
      lifeSpan: data.lifeSpan,
      pc180Score: data.pc180Score,
      sizes: data.sizes.reduce<number[]>(
        (acc, val) => [...acc, ...val.sizes],
        [],
      ),
    };
  }

  return {
    isVIP: false,
    lifeSpan: 0,
    pc180Score: 0,
    sizes: [],
  };
};

export const useCustomerLikedBrandIds = () => {
  const customerData = useCustomerResponse().data;

  return customerData ? customerData.brands.liked : undefined;
};
